import api from '../config/api';
import {
  FETCH_BALANCE_LOADING,
  FETCH_BALANCE_SUCCESS,
  FETCH_BALANCE_ERROR,
  UPDATE_USER_BALANCE_LOADING,
  UPDATE_USER_BALANCE_SUCCESS,
  UPDATE_USER_BALANCE_ERROR,
  FETCH_HISTORY_LOADING,
  FETCH_HISTORY_SUCCESS,
  FETCH_HISTORY_ERROR,
  FETCH_USER_HISTORY_LOADING,
  FETCH_USER_HISTORY_SUCCESS,
  FETCH_USER_HISTORY_ERROR
} from '../Types/balanceTypes';

const API_URL = process.env.REACT_APP_API_URL;

export const fetchBalances = (type = 'active', date = null) => {
  return async dispatch => {
    dispatch({ type: FETCH_BALANCE_LOADING });
    try {
      const url = date
        ? `${API_URL}Balance/getUsersBalances/${type}/${date}`
        : `${API_URL}Balance/getUsersBalances/${type}`;

      const response = await api.get(url);
      dispatch({
        type: FETCH_BALANCE_SUCCESS,
        payload: response.data.data
      });
    } catch (error) {
      dispatch({
        type: FETCH_BALANCE_ERROR,
        payload: error.message
      });
    }
  };
};

export const fetchHistoryBalances = (startDate, endDate) => {
  return async dispatch => {
    dispatch({ type: FETCH_HISTORY_LOADING });

    try {
      const response = await api.get(
        `${API_URL}History/getHistoryBalances/${startDate}/${endDate}`
      );

      // Ensure we have the correct data structure
      if (response.data?.status === 200 && Array.isArray(response.data?.data)) {
        const historyData = response.data.data.filter(item =>
          item.TransactionType.includes('LEAVE')
        );

        dispatch({
          type: FETCH_HISTORY_SUCCESS,
          payload: historyData
        });

        return historyData;
      } else {
        throw new Error('Invalid data structure received from server');
      }
    } catch (error) {
      console.error('History fetch error:', error);
      dispatch({
        type: FETCH_HISTORY_ERROR,
        payload: error.response?.data?.message || error.message
      });
    }
  };
};

export const updateUserBalance = (id, data, type = 'active') => {
  return async dispatch => {
    dispatch({ type: UPDATE_USER_BALANCE_LOADING });
    try {
      const response = await api.put(`${API_URL}Balance/updateUserBalance/${id}`, data);
      dispatch({ type: UPDATE_USER_BALANCE_SUCCESS, payload: response.data.data });
      // Refresh the balances after update with the current type
      dispatch(fetchBalances(type));
    } catch (error) {
      dispatch({ type: UPDATE_USER_BALANCE_ERROR, payload: error.message });
    }
  };
};

export const fetchUserHistory = id => {
  return dispatch => {
    dispatch({ type: FETCH_USER_HISTORY_LOADING });
    const url = `${API_URL}history/cardhistory/${id}`;
    console.log('Fetching from URL:', url);

    api
      .get(url)
      .then(response => {
        console.log('Response:', response.data);
        dispatch({
          type: FETCH_USER_HISTORY_SUCCESS,
          payload: response.data.data
        });
      })
      .catch(error => {
        console.error('Error fetching user history:', error);
        console.error('Full error response:', error.response);
        dispatch({
          type: FETCH_USER_HISTORY_ERROR,
          payload: error.message
        });
      });
  };
};
